import { Component, Input, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ConstantesConfiguracionCalendarioEnum } from '@appNeo/core/helpers/enums/constantesConfiguracionCalendarioEnum';
import { IPaquete } from '@appNeo/core/interfaces/IPaquete';
import { PreferenciasService } from '@appNeo/neoCore/services/preferencias/preferencias.service';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { ProximamenteDlgComponent } from '@appNeo/pages/components/proximamente-dlg/proximamente-dlg.component';

import { PAGINAS_ROUTES } from '@appNeo/pages/pages-routes-data';
import { environment } from '@environments/environment';
import { finalize } from 'rxjs';

@Component({
  selector: 'neo-bloque-cumpleanos[paquete]',
  templateUrl: './bloque-cumpleanos.component.html',
  styleUrls: ['./bloque-cumpleanos.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BloqueCumpleanosComponent implements OnInit {
  @ViewChildren(ProximamenteDlgComponent) accionesDialogoProximamente: QueryList<ProximamenteDlgComponent>;
  @Input() paquete: IPaquete;
  @Input() pathReservar: string = PAGINAS_ROUTES.PAGINA_RESERVAR;
  @Input() constanteComprobarAccion = ConstantesConfiguracionCalendarioEnum.AccesoAltaReservasPublico;
  constructor(
    private router: Router,
    private preferenciasService: PreferenciasService,
    private auxiliarService: AuxiliarService
  ) { }

  ngOnInit(): void {
  }

  get identificadorArticle() {
    return (this.paquete?.nombre) ? this.paquete?.nombre.replace(/ /g, "-").toLowerCase() : '';
  }

  get duracion() {
    return (this.paquete?.duracionEvento > 0) ? this.paquete.duracionEvento / 60 : 0;
  }

  get nombre() {
    return this.campoTraduccion('nombre');
  }

  get descripcion() {
    return this.campoTraduccion('descripcion');
  }

  get descripcionHorario() {
    return this.campoTraduccion('descripcionHorario');
  }

  get descripcionExtra() {
    return this.campoTraduccion('descripcionExtra');
  }


  get textoEdadMinima() {
    return this.campoTraduccion('textoEdadMinima');
  }
  campoTraduccion(campo, claveIdioma = 'es') {
    return (this.paquete?.idiomas[claveIdioma][campo]) ? this.paquete?.idiomas[claveIdioma][campo] : '';
  }

  reservar(idPaquete) {
    this.validarAccion(idPaquete);
  }

  desencadenarAccion: boolean = !environment.proximamente_reservas;
  accion(data: any) {
    if (this.desencadenarAccion) {
      this.router.navigate([`/${this.pathReservar}`, data]);
    } else {
      this.mostrarProximamente();
    }
  }
  validarAccion(data: any) {
    this.preferenciasService.getApi(this.constanteComprobarAccion, true)
      .pipe(
        finalize(() => {
          this.accion(data);
        })
      )
      .subscribe(
        x => this.desencadenarAccion = this.auxiliarService.getBoolean(x.valor),
        e => this.desencadenarAccion = this.auxiliarService.getBoolean(this.preferenciasService.get(this.constanteComprobarAccion))
      );
  }
  mostrarProximamente() {
    this.accionesDialogoProximamente.first.abrirDialogo();
  }

}
